import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { get } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private key = 'PCTOKEN';

  get authorization(): string {
    return `${this.getToken('token_type')} ${this.getToken('access_token')}`;
  }

  constructor(private router: Router) {}

  hasToken(): boolean {
    return !!this.getToken();
  }

  getToken(...value: Array<string>): any {
    let token: any;

    try {
      const item = localStorage.getItem(this.key);
      token = item ? JSON.parse(item) : null;
    } catch (error) {}

    if (value.length > 0) {
      value.forEach((key) => {
        token = get(token, key, null);
      });
    }
    return token;
  }

  setToken(value: any): void {
    localStorage.setItem(this.key, JSON.stringify(value));
  }

  addValue(key: string, value: any): void {
    const token = this.getToken() || {};
    token[key] = value;
    this.setToken(token);
  }

  removeTokenAndLogout(): void {
    const token = this.getToken();
    const alias = token ? token['alias'] : null;
    const aliasSource = token ? token['aliasSource'] : null;
    localStorage.removeItem(this.key);

    const target = aliasSource === 'suffix' && alias ? `/login/${alias}` : '/login';
    const currentUrl = this.router.url || '';

    if (!currentUrl.includes(target)) {
      this.router.navigate([target]);
    }
  }

  removeToken(): void {
    localStorage.removeItem(this.key);
  }
}
